import React from 'react';
import { Link } from 'react-router-dom';
import Exprience from './exprience/exprience.jsx';
import HeroSlider from './heroslider/heroslider.jsx';
import Homequotation from './quotation/homequotation.jsx';
import Package from '../package/package.jsx';
import Design from '../Home/homedesign/design.jsx';
import Work from '../Home/somework/work.jsx';
import Accordian from '../Home/accordian/accordian.jsx';
import Success from '../Home/success/success.jsx';
import Tesimonial from '../Home/powerfull/powerfull.jsx';
import './home.css';
import abimg1 from "../../images/c1 (1).png";
import abimg2 from "../../images/c1 (2).png";
import abimg3 from "../../images/c1 (3).png";
import abimg4 from "../../images/c1 (4).png";
import { Helmet } from "react-helmet-async";

function Home() {

  return (
    <>
      <Helmet>
        <title>Interior Designers in Palakkad | Cedar Interiors</title>
        <meta name="description" content="Welcome to Cedar Interiors. Redefining interiors with bespoke designs for modular kitchens, living rooms, and more. Elevate your living experience today." />
      </Helmet>

      <HeroSlider />
      <section className="home-intro-section">
        <div className="home-intro-container">
          <div className="home-intro-left">
            <h2>Interior Designers in Palakkad – Transforming Spaces with Style</h2>
            <p>
              If you are looking for professional <strong>Interior designers in Palakkad</strong>, you’ve come to the right place. We specialize in creating elegant, functional, and personalized interiors for homes, offices, and commercial spaces. Our design team combines creativity with modern trends to transform ordinary spaces into beautiful living environments.
            </p>
            <p>
              As one of the trusted <strong>Interior designers in Palakkad</strong>, we focus on understanding your lifestyle, preferences, and budget before designing your space. Whether you want a modern minimalist home, a luxurious villa interior, or a smart office design, we deliver solutions that perfectly match your vision.
            </p>
            <div className="home-intro-buttons">
              <Link to="/2bhk-3bhk-interior-packages" className="home-intro-btn">
                Interior Design Packages
              </Link>
              <Link to="/gallery" className="home-intro-btn home-intro-btn-outline">
                Gallery
              </Link>
            </div>
          </div>
          <div className="home-intro-right">
            <h3>Why Choose Our Interior Designers in Palakkad?</h3>
            <p>
              Choosing the right interior designer can completely change the look and feel of your property. Our experienced team ensures every project is handled with attention to detail and quality craftsmanship.
            </p>
            <p>Our advantages include:</p>
            <ul>
              <li>Customized interior design solutions</li>
              <li>Modern and innovative space planning</li>
              <li>High-quality materials and finishes</li>
              <li>Affordable design packages</li>
              <li>On-time project completion</li>
              <li>Professional project management</li>
            </ul>
            <p className="home-intro-bottom">
              With years of experience in residential and commercial interiors, our team has built a reputation as one of the most reliable <strong>Interior designers in Palakkad</strong>.
            </p>
          </div>
        </div>
      </section>
      <Exprience />
      <Homequotation />
      <section className="home-services-section">
        <div className="home-services-container">
          <div className="home-services-intro">
            <h2>CEDAR INTERIORS - Trusted Interior Designers in Palakkad for Every Space</h2>
            <p>
              Whether you are building a new home, renovating an existing property, or designing a commercial space, our expert team is ready to help. We take pride in delivering creative designs that combine beauty, comfort, and practicality.
            </p>
            <p>
              If you are searching for <a href="https://blog.cedarinteriors.in/" target="_blank" rel="noopener noreferrer"><strong>reliable Interior designers in Palakkad</strong></a>, contact us today to discuss your project and bring your dream space to life.
            </p>
          </div>
          
          <div className="home-services-grid-wrapper">
            <div className="home-services-grid-header">
              <h3>Our Interior Design Services in Palakkad</h3>
              <p>We provide a wide range of interior design services to meet different client needs.</p>
            </div>
            
            <div className="home-services-grid">
              <div className="home-service-card">
                <h4>Home Interior Design</h4>
                <p>We create stylish and comfortable living spaces including living rooms, bedrooms, kitchens, and dining areas. Our designs focus on aesthetics, storage solutions, and functionality.</p>
              </div>
              <div className="home-service-card">
                <h4>Modular Kitchen Design</h4>
                <p>Our modular kitchen solutions are designed to make cooking easier and more efficient while maintaining a modern and elegant look.</p>
              </div>
              <div className="home-service-card">
                <h4>Office Interior Design</h4>
                <p>We design productive workspaces with smart layouts, ergonomic furniture, and professional aesthetics to enhance employee performance and client impressions.</p>
              </div>
              <div className="home-service-card">
                <h4>Commercial Interior Design</h4>
                <p>From retail stores to restaurants and showrooms, our commercial interiors are designed to attract customers and enhance brand identity.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Design />
      <Package />
      {/* <Chooseus/> */}
      <div className="aboutchoose">
        <div className="aboutchoosrow1">
          <div className="aboutchooserow1col col1">
            <h2 className="header2">Cedar Assurance</h2>
            <p>
              Cedar Assurance is our promise to make your interior journey seamless and stress-free. We go beyond delivering beautiful spaces by ensuring every detail reflects quality, precision, and care. With our unwavering commitment to innovation and client satisfaction, Cedar Interiors stands as your trusted partner in creating timeless spaces that inspire.
            </p>
          </div>
          <div className="aboutchooserow1col col2">
            <div className="yofexp">
              <p>45</p>
              <span>Days</span>
              <span>Delivery</span>
            </div>

            <div className="yofexp">
              <p>4Lakh</p>
              <span>SqFt</span>
              <span>Developed</span>
            </div>
            <div className="yofexp">
              <p>10</p>
              <span>Years</span>
              <span>Warranty</span>
            </div>
          </div>
        </div>
        {/*end*/}
        <div className="about-card">
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg1} alt="" />
              <h4>45 Days Delivery</h4>
              <p>
                Enjoy fast and reliable interior solutions for your new home with our guaranteed 45-day delivery. Your dream home, delivered on time.
              </p>
            </div>
          </div>
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg2} alt="" />
              <h4>Design Experts</h4>
              <p>
                Collaborate with our skilled designers to explore premium ideas and co-create interiors that match your unique style and vision.
              </p>
            </div>
          </div>
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg3} alt="" />
              <h4>Aftercare Service</h4>
              <p>
                Experience uninterrupted support with our dedicated customer care team, ensuring your interiors remain flawless even after project completion.
              </p>
            </div>
          </div>
          <div className="about1-col">
            <div className="blurb">
              <img src={abimg4} alt="" />
              <h4>10-Year Warranty</h4>
              <p>
                Benefit from high-quality materials and craftsmanship backed by a 10-year warranty for a defect-free and lasting experience.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Work />
      <Success />
      <Tesimonial />
      <Accordian />
    </>

  );
}

export default Home;

